<template>
  <div>
    <news-header
      :actIndex="actIndex"
      :imgList="imgList"
      :topStyle="topStyle"
      :logo="logo"
    ></news-header>
    <news-center
      :type="newsType"
      :news="newsList"
      :teamList="teamList"
      ref="newsRef"
    ></news-center>
    <news-footer :bottom="bottom" :bottomInfo="bottomInfo"></news-footer>
  </div>
</template>

<script>
import NewsHeader from "@/components/mobile/Header";
import NewsCenter from "@/components/mobile/NewsCenter";
import NewsFooter from "@/components/mobile/Footer";
export default {
  name: "News",
  data() {
    return {
      actIndex: 7,
      topStyle: "",
      imgList: [],
      bottom: {},
      logo: "",
      bottomInfo: {},
      newsType: [],
      newsList: [],
      teamList: {},
    };
  },
  components: {
    NewsHeader,
    NewsCenter,
    NewsFooter,
  },
  watch: {
    cases(newVal) {
      this.caseData = newVal;
    },
  },
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    Pc_Mobile() {
      if (this._isMobile()) {
        this.$router.push("/m_news");
      } else {
        this.$router.push("/news");
      }
    },
    getPageData() {
      this.$http.post("home/index/m_news", null, (res) => {
        // console.log(res.data)
        this.bottom = res.data.bottom[0];
        this.logo = this.bottom.logo;
        // this.topStyle = "background:url('"+this.$imgUrl+res.data.header[0].m_xwzx.replace(/\\/g,'/')+"')"
        this.bottomInfo = res.data.contact[0];
        // this.newsType = res.data.type;
        this.newsList = res.data.new;
        this.teamList = res.data.team;
        this.$nextTick(() => {
          this.$refs.newsRef.imgSwiper();
        });
      });
    },
      getNewsType() {
      this.$http.post(
        "https://eartisanapplets.wsandos.com/api/index/newsType",
        null,
        (res) => {
          if (res.code == 1) {
            this.newsType = res.data;
          }
        }
      );
    },
    getNewsList() {
      this.$http.post(
        "https://eartisanapplets.wsandos.com/api/index/news",
        { type_one: 1 },
        (res) => {
          // console.log(res.data)
          if (res.code == 1) {
            this.newsList = res.data;
          }
        }
      );
    },
    getHeaderImage() {
      this.$http.post(
        "https://eartisanapplets.wsandos.com/api/index/special",
        { type_two: this.actIndex },
        (res) => {
          if (res.code == 1) {
            this.topStyle =
              "background-image:url('" + res.data.phone_image + "')";
          }
        }
      );
    },
  },
  mounted() {
    this.Pc_Mobile();
    this.getPageData();
    this.getHeaderImage();
    this.getNewsType();
    // this.getNewsList();
  },
};
</script>

<style lang="stylus" scoped></style>


// WEBPACK FOOTER //
// src/views/mobile/News.vue